<div class="col-md-6" *ngIf="translated" ipsFocus="searchInput">
    <ips-list-search headerLabel="{{'RELATED_SPACES' | translate }}"
                     [searchLabel]="searchLabel"
                     [searchLabelPlural]="searchLabelPlural"
                     labelLoading="{{'ACCESSING_VERSION_INFO' | translate }}"
                     labelLoadingError="{{'ERROR_ACCESSING_VERSION_INFO' | translate }}"
                     [listData]="holderversion"
                     [busy]="busy"
                     (onListDataChange)="getListData($event.search)"
                     [section]="'main.storeProfileHolderVersion'"
                     [scroller]=true
                     [quickRef]=false
                     [itemClickPermission]="'main.storeProfileHolderVersion.view'"
                     [promise]="promise"
                     [createNewTooltip]="createNewTooltip"
                     [autoFocus]=true></ips-list-search>
</div>
